import { SubmenuDivHandler } from './SubmenuDivHandler.js';
import { EventsClient } from '../events-client.js';
import { EToyType } from '../etoy/etoy-types.js';
import { applyComponentStyles } from '../utils/shared-styles.js';
import Logger from '../utils/logger.js';

const MODULE = 'EToySubmenu';

const CSS = `
        .mm-etoy-actions {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            align-items: center;
            justify-content: center;
        }
`;

const MM_ETOY_HTML = `
        <div id="menu-modal-etoy" class="menu-modal-content">
            <h2>EToys</h2>
            <div class="mm-etoy-actions">
                <button id="mm-etoy-add-ball-button" class="mm-submit-button">Add Ball</button>
                <button id="mm-etoy-add-proxvibe-button" class="mm-submit-button">Add Proximity Vibrator</button>
                <button id="mm-etoy-add-oscrot-button" class="mm-submit-button">Add Oscillating Rotator</button>
                <button id="mm-etoy-clear-button" class="mm-submit-button">Clear All EToys</button>
            </div>
        </div>
`;

export class EToySubmenuDH extends SubmenuDivHandler {
    static TypeName = 'EToySubmenuDH';

    constructor() {
        super();
        applyComponentStyles(CSS, 'etoy-submenu');
    }

    updateConditionals(): void {
        // No dynamic enable/disable needed yet
    }

    displayMenuContent(containerDiv: HTMLDivElement): void {
        containerDiv.innerHTML = MM_ETOY_HTML;

        const btnAddBall = document.getElementById('mm-etoy-add-ball-button') as HTMLButtonElement | null;
        const btnAddProxVibe = document.getElementById('mm-etoy-add-proxvibe-button') as HTMLButtonElement | null;
        const btnAddOscRot = document.getElementById('mm-etoy-add-oscrot-button') as HTMLButtonElement | null;
        const btnClear = document.getElementById('mm-etoy-clear-button') as HTMLButtonElement | null;
        if (!btnAddBall || !btnAddProxVibe || !btnAddOscRot || !btnClear) {
            Logger.error(MODULE, 'Could not find EToy buttons');
            return;
        }

        btnAddBall.addEventListener('click', () => {
            EventsClient.instance.requestToyCreate(EToyType.BALL);
        });

        btnAddProxVibe.addEventListener('click', () => {
            EventsClient.instance.requestToyCreate(EToyType.PROXIMITY_VIBE);
        });

        btnAddOscRot.addEventListener('click', () => {
            EventsClient.instance.requestToyCreate(EToyType.OSCILLATING_ROT);
        });

        btnClear.addEventListener('click', () => {
            EventsClient.instance.requestToyDeleteAll();
        });
    }

    hideContent(): void {
        const btnAddBall = document.getElementById('mm-etoy-add-ball-button');
        const btnAddProxVibe = document.getElementById('mm-etoy-add-proxvibe-button');
        const btnAddOscRot = document.getElementById('mm-etoy-add-oscrot-button');
        const btnClear = document.getElementById('mm-etoy-clear-button');
        const cloneAdd = btnAddBall?.cloneNode(true);
        const cloneClear = btnClear?.cloneNode(true);
        if (btnAddBall && cloneAdd) {
            btnAddBall.parentNode?.replaceChild(cloneAdd, btnAddBall);
        }
        if (btnAddProxVibe && cloneAdd) {
            btnAddProxVibe.parentNode?.replaceChild(cloneAdd, btnAddProxVibe);
        }
        if (btnAddOscRot && cloneAdd) {
            btnAddOscRot.parentNode?.replaceChild(cloneAdd, btnAddOscRot);
        }
        if (btnClear && cloneClear) {
            btnClear.parentNode?.replaceChild(cloneClear, btnClear);
        }
    }
}
